<template>
  <div class="pastel-wrapper">
    <!-- PastelのSVGクリッピングパス -->
    <svg width="0" height="0" style="position: absolute;">
      <defs>
        <clipPath
          id="pastelClipPath"
          clipPathUnits="objectBoundingBox"
          transform="scale(0.00066050, 0.00065274)"
        >
          <path
            d="M1514 777.034C1514 1286.65 1221 1532 755 1532C335.816 1532 0 1141.48 0 777.034C0 408.589 244.968 132.994 755 18.067C1269.03 -96.8599 1514 357.868 1514 777.034Z"
          />
        </clipPath>
      </defs>
    </svg>

    <div class="cover-front-title">
      <div class="cover-front-organization-name">{{ organizationName }}</div>
      <div class="cover-front-title-text">
        <img
          :src="
            require('../../../../assets/images/combook_binding/cover_front_title_pastel.svg')
          "
          alt="表紙タイトル"
        />
      </div>
      <div class="cover-kid-name">{{ kidName }}</div>
    </div>
    <slot name="photo-editor"></slot>
    <div class="cover-front-month-wrapper">
      <div class="cover-front-month">{{ displayYearMonth }}</div>
      <div class="cover-front-number">
        <div>{{ startMonth }}</div>
        <div class="cover-front-number-hyphen">
          <img
            :src="
              require('../../../../assets/images/combook_binding/cover_front_pastel_hyphen.svg')
            "
            alt="ハイフン"
          />
        </div>
        <div>{{ endMonth }}</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "PastelCover",

  props: {
    organizationName: {
      type: String,
      required: true
    },
    kidName: {
      type: String,
      required: true
    },
    displayYearMonth: {
      type: String,
      required: true
    },
    startMonth: {
      type: String,
      required: true
    },
    endMonth: {
      type: String,
      required: true
    }
  }
});
</script>

<style scoped>
.pastel-wrapper {
  font-family: "Zen Maru Gothic", "ChironGoRoundTCVF", "Noto Sans JP",
    "Noto Sans SC", "Noto Sans TC", "Noto Sans KR", "Noto Sans Devanagari",
    "Hind Siliguri", "Noto Sans Myanmar", "Noto Sans Tamil", "Noto Sans Thai",
    "Noto Color Emoji", sans-serif !important;
}

/* cover-front-title */
.cover-front-title {
  margin-top: calc(170px * var(--scale-factor));
  margin-left: 0;
  display: flex;
  align-items: center;
  flex-flow: column;
  position: relative;
  text-align: center;
}

.cover-front-organization-name {
  font-size: calc(60px * var(--scale-factor));
  line-height: 1;
  letter-spacing: 0;
  /* 半角スペースを入力通りに表示するため */
  white-space: pre-wrap;
}

.cover-front-title-text {
  width: calc(1005.63px * var(--scale-factor));
  margin: calc(67.1px * var(--scale-factor)) 0 calc(76px * var(--scale-factor));
}

.cover-front-title-text img {
  width: 100%;
  height: auto;
  display: block;
}

.cover-kid-name {
  font-size: calc(60px * var(--scale-factor));
  line-height: 1;
  letter-spacing: 0;
  /* 半角スペースを入力通りに表示するため */
  white-space: pre-wrap;
}

/* cover-front-month-wrapper */
.cover-front-month-wrapper {
  position: absolute;
  bottom: calc(129px * var(--scale-factor));
  right: calc(144px * var(--scale-factor));
  width: calc(418px * var(--scale-factor));
  height: calc(430px * var(--scale-factor));
  background-image: url("../../../../assets/images/combook_binding/cover_front_bg_month_pastel.png");
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-flow: column;
  align-items: center;
  font-weight: 400;
  text-align: right;
  font-weight: bold;
  color: #3d3128;
}

.cover-front-month {
  font-size: calc(47px * var(--scale-factor));
  line-height: 1;
  margin-top: calc(128px * var(--scale-factor));
  margin-bottom: calc(27px * var(--scale-factor));
  padding-right: 0;
  text-align: center;
}

.cover-front-number {
  min-width: calc(281px * var(--scale-factor));
  font-size: calc(125.3px * var(--scale-factor));
  line-height: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: calc(4px * var(--scale-factor)) solid #3d3128;
  padding-top: calc(22px * var(--scale-factor));
  margin-top: 0;
}

.cover-front-number div {
  line-height: 1;
}

.cover-front-number-hyphen {
  width: calc(22px * var(--scale-factor));
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 0;
  margin-left: calc(4px * var(--scale-factor));
  margin-right: calc(4px * var(--scale-factor));
}

.cover-front-number-hyphen img {
  width: calc(22px * var(--scale-factor));
  height: calc(14px * var(--scale-factor));
}
</style>
